import { GroupTableType } from "helpers/models";
import { Content } from "pdfmake/interfaces";
import getSum from "report/common/sum";
import getSvg from "./util";
import getOption from "./option";
import gap from "report/common/gap";
import getTitle from "report/common/title";

const get = async (
  t: any,
  grouped: GroupTableType,
  title: string
): Promise<Content[]> => {
  const maxCount = getSum(grouped);

  const option = getOption(t, grouped, maxCount, title);

  const image = await getSvg(option, Object.keys(grouped).length);

  return [
    {
      stack: [
        getTitle(title, 12),
        gap(10),

        {
          svg: image
        }
      ],
      unbreakable: true
    }
  ];
};

export default get;
